import { observable, runInAction } from "mobx";
import { RootStore } from "./stores";
import { UserModel } from "../models";
import { RequestRouteUserGet, ParamsRouteUserGet, ResponseRouteUserGet, locationRestUserGet } from "../wp-api";
import { request } from "../utils";
import { BaseStore } from "./base";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
/**
 * Do a test ajax call when clicking the REST API url.
 *
 * @param e
 */

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
class UserStore extends BaseStore {
    @observable
    public users: UserModel[] = [];

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    async getUsers(query: string) {
        runInAction(() => {
            this.loading = true;
        });
        try {
            const result = await request<RequestRouteUserGet, ParamsRouteUserGet, ResponseRouteUserGet>({
                location: locationRestUserGet,
                params: {
                    s: query
                }
            });
            runInAction(() => {
                this.users = result.data;
                this.errors = result.errors;
                this.errorType = "warning";
            });
        } catch (e) {
            //console.log(e.responseJSON);
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }
}

export { UserStore };
